export * from './dees-table.js';
